module.exports = __webpack_public_path__ + "static/media/5-A-World-Without-Police.7ee8f499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/5-A-World-Without-Police.jpg
// module id = 141
// module chunks = 0